import axios from "axios";
import { getTokenFromCookies } from "@/utils/common";
import store from "@/store";
import router from "@/router";
import type { ApiError } from "@/struct/ApiError";

const api = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 10000,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = getTokenFromCookies();
  if (token) {
    config.headers["x-session-token"] = token;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.error("API Error:", error);

    const apiError: ApiError = {
      code: error.response?.data?.code,
      status: error.response?.status,
      message:
        error.response?.data?.message ?? error.message ?? "Unknown API error",
    };
    error.apiError = apiError;

    const isUnauthorized = error.response?.status === 401;
    const isLogoutRequest = error.config?.url?.includes("/logout");

    if (isUnauthorized && !isLogoutRequest) {
      if (getTokenFromCookies()) {
        await store.dispatch("auth/logout");
      }
      router.push({ name: "Login" });
    }

    return Promise.reject(error);
  }
);

export default api;
